import React, { ChangeEvent } from 'react';
import styles from './Radio.module.scss';
import RadioIcon from '../../assets/icons/radio.svg?react';
import RadioFillIcon from '../../assets/icons/radio_fill.svg?react';
import TextSpeech from '../text-speech/TextSpeech';

type Props = {
  id: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  name: string;
  label?: string;
  children?: React.ReactNode;
  touchable?: boolean;
  needSpeak?: boolean;
  isAU?: boolean;
};

function Radio(props: Props) {
  const { checked, onChange, label, children, name, touchable, needSpeak, isAU=false } = props;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <label className={touchable ? [styles.touchableWrapper, checked ? styles.active : ''].join(' ') : styles.wrapper} onClick={() => onChange(!checked)}>
      {!touchable && (checked ? <RadioFillIcon/> : <RadioIcon/>)}
      <input className={styles.input} name={name} type="radio" checked={checked} onChange={handleChange}/>
      {children && !label ? children : <span className={styles.label}>{label}
        {needSpeak && <TextSpeech text={label ?? ''} isAU={isAU} />
        }
      </span>}
    </label>
  );
}

export default Radio;
